import { render, staticRenderFns } from "./transferDeposit.vue?vue&type=template&id=5bca61b6&scoped=true"
import script from "./transferDeposit.vue?vue&type=script&lang=js"
export * from "./transferDeposit.vue?vue&type=script&lang=js"
import style0 from "./transferDeposit.vue?vue&type=style&index=0&id=5bca61b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca61b6",
  null
  
)

export default component.exports